import { createContext } from 'react';

const WithinContentContext = /*#__PURE__*/createContext(false);

export { WithinContentContext };
